#import "../../../approvalSetup/ApprovalsListFields.graphql"

mutation ApprovalFlowCreate($input: ApprovalCreateInput!) {
  approvalCreate(input: $input) {
    clientMutationId
    approval {
      ...ApprovalsListFields
    }
    query {
      activeApprovalTypes(orderBy: APPROVAL_TYPE_ASC, isAllPhases: true) {
        nodes {
          id
          approvalType
          _activeCount
        }
      }
    }
  }
}
